<template>
  <div class="black_panel_cla">
    <zk-table
      :data="tableData"
      :columns="columnData"
      style="min-height:300px;height: auto;"
    ></zk-table>
    <div class="pagination-margin-top">
      <el-pagination
        background
        @size-change="changePageSize"
        @current-change="changePage"
        :current-page="pager.curPage"
        :page-size="pager.pageSize"
        layout="total, prev, pager, next, sizes, jumper"
        :total="pager.total"
      ></el-pagination>
    </div>
    <el-drawer :with-header="false" :visible.sync="drawer" direction="rtl">
      <div class="group-info-cla">
        {{ $t('accManager.timeSlotDetails') }}
      </div>
      <el-form style="padding:10px 40px" ref="form" label-width="80px">
        <el-form-item :label="$t('accManager.number')">
          <el-input disabled v-model="currentDetails.groupNum"></el-input>
        </el-form-item>
        <el-form-item :label="$t('accManager.name')">
          <el-input disabled v-model="currentDetails.groupName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('accManager.timezone')">
          <el-input disabled v-model="currentDetails.timezoneName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('accManager.daterange')">
          <div class="daterange-cla">
            <el-input
              placeholder=""
              disabled
              v-model="currentDetails.startTime"
            >
            </el-input>
            <span style="padding:0px 5px">~</span>
            <el-input
              disabled
              placeholder=""
              v-model="currentDetails.endTime"
            >
            </el-input>
          </div>
        </el-form-item>
      </el-form>

      <div class="employee-info-cla">
        {{ $t('accManager.distributionPersonnel') }}
      </div>
      <ul class="employeeList-cla">
        <li
          class="employee-item-cla"
          :key="item.employeeNo"
          v-for="item of currentDetails.levelEmployeeList"
        >
          <el-avatar
            shape="square"
            :size="50"
            class="photo-cla"
            :src="item.photo || defaultHeader"
          >
          </el-avatar>
          <div class="employee-info">
            <div>{{ item.formattedName }}</div>
            <div>{{ item.employeeNo }}</div>
          </div>
        </li>
      </ul>

      <div class="door-info-cla">
        {{ $t('accManager.distributionDoor') }}
      </div>
      <ul class="doorList-cla">
        <li
          class="dooritem-cla"
          :key="item.sn"
          v-for="item of currentDetails.levelDoorList"
        >
          <el-image class="photo-cla" :src="doorImage" fit="fill"> </el-image>
          <div class="doorInfo-cla">
            <div>{{ item.sn }}</div>
            <div>
              <span class="doorDevice-online-cla" v-if="item.devStatus === 1">{{
                $t('device.online')
              }}</span>
              <span class="doorDevice-offline-cla" v-else>{{
                $t('device.offLine')
              }}</span>
            </div>
          </div>
        </li>
      </ul>
    </el-drawer>
  </div>
</template>
<script>
import {
  findLevelByPage,
  findLevelDetailByGroupNum
} from '@/services/accManager.js'
export default {
  data() {
    return {
      tableData: [],
      params: {},
      defaultHeader: require('@/assets/new/default_head.png'),
      doorImage: require('@/assets/new/door.png'),
      drawer: false,
      currentDetails: {},
      currentDatetimerange: [],
      columnData: [
        {
          label: this.$t('accManager.groupName'),
          prop: 'groupName'
        },
        {
          label: this.$t('accManager.timezoneName'),
          prop: 'timezoneName'
        },
        {
          label: this.$t('common.action'),
          prop: 'timezoneNum',
          render: (h, params) => {
            return h(
              'span',
              {
                class: {
                  'action-btn-cla': true
                },
                on: {
                  click: () => {
                    this.details(params.row)
                  }
                }
              },
              [this.$t('common.details')]
            )
          }
        }
      ]
    }
  },
  mounted() {
    this.commQuery()
  },
  methods: {
    details(row) {
      this.drawer = false
      findLevelDetailByGroupNum({
        groupNum: row.groupNum
      })
        .then(data => {
          if (data.code === '00000000') {
            this.drawer = true
            this.currentDetails = data.payload.results
            this.currentDatetimerange = [
              this.currentDetails.startTime,
              this.currentDetails.endTime
            ]
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage()
        })
    },
    changePage(current) {
      this.pager.curPage = current
      this.commQuery()
    },
    changePageSize(pageSize) {
      this.pager.pageSize = pageSize
      this.commQuery()
    },
    commQuery() {
      findLevelByPage({
        params: this.params,
        pager: this.pager
      })
        .then(data => {
          if (data.code === '00000000') {
            let payload = data.payload
            this.pager.total = payload.totalRecords
            this.pager.curPage = payload.curPage
            this.pager.pageSize = payload.pageSize
            this.tableData = payload.results
          } else {
            this.errorMessage(data.message)
          }
        })
        .catch(data => {
          this.errorMessage()
        })
    }
  }
}
</script>
<style scoped lang="less">
@import '~@/styles/var.less';
/deep/.action-btn-cla {
  cursor: pointer;
}

.details-title-cla {
  position: absolute;
  height: 15px;
  left: 15px;
  top: 5px;
}

.group-info-cla,
.employee-info-cla,
.door-info-cla {
  position: relative;
  padding-left: 30px;
  height: 25px;
  line-height: 25px;
}
.group-info-cla::before {
  content: '';
  .details-title-cla;
  border-left: 5px solid @statusSuccess;
}

.employee-info-cla::before {
  content: '';
  .details-title-cla;
  border-left: 5px solid @statusWarning;
}

.door-info-cla::before {
  content: '';
  .details-title-cla;
  border-left: 5px solid @statusNormal;
}

.employeeList-cla {
  display: flex;
  flex-wrap: wrap;
}
.photo-cla {
  width: 50px;
  height: 50px;
}
.dooritem-cla,
.employee-item-cla {
  margin-bottom: 10px;
  display: flex;
  flex-wrap: nowrap;
  min-width: 140px;
  align-items: center;
  margin-right: 20px;
  padding: 5px;
  border-radius: 5px;
  border: 1px solid gray;
}
.employee-info,
.doorInfo-cla {
  margin-left: 10px;
  div {
    height: 25px;
    line-height: 25px;
    color: rgba(0, 0, 0, 0.65);
    font-size: 14px;
  }
}
.doorList-cla {
  display: flex;
  flex-wrap: wrap;
}

.daterange-cla {
  display: flex;
  flex-wrap: nowrap;
}

/deep/.doorDevice-online-cla {
  color: @themeColor;
}
/deep/.doorDevice-offline-cla {
  color: @ststusFailed;
}
</style>



// WEBPACK FOOTER //
// src/modules/accManager/accManager/permissionGroup.vue